import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';
import { UPDATES } from '../../content/updates';

function Updates({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('updates_title')}</h1>
      <p>{t('updates_intro')}</p>

      <div className="page-card-list">
        {UPDATES.map((u) => (
          <article className="page-card" key={u.id}>
            <h2 className="page-card-title">{t(u.titleKey)}</h2>
            <p className="page-card-meta">{u.date}</p>
            {u.bodyKeys.map((k) => (
              <p key={k}>{t(k)}</p>
            ))}
          </article>
        ))}
      </div>

      <button className="back-button" onClick={onBack}>
        {t('back_to_home')}
      </button>
    </div>
  );
}

export default Updates;
